"use strict";

$(document).ready(function () {
  $(document).on('click', '.mobile-filter-caller', function () {
    console.log($(this));
    console.log($('body').hasClass('has-compact-filter') && !$('body').hasClass('show-filter'));
    console.log($('body').hasClass('has-compact-filter'));
    console.log(!$('body').hasClass('show-filter'));

    if ($('body').hasClass('has-compact-filter') && !$('body').hasClass('show-filter')) {
      $('body').addClass('show-filter');
    }
  });
  selectCategoryInner();

  if ($('body#category').length > 0) {
    facetedOverride();
  }

  $(document).on('click', '#amazzing_filter .close-btn-block .close-btn', function (e) {
    $('body').removeClass('show-filter');
  });
  $(document).on('click', '#amazzing_filter .amazzing-apply-btn', function (e) {
    $('body').removeClass('show-filter');
  });

  if ($('.navbar-toggler.collapse-icons').length > 0) {
    $(document).on('click', '.navbar-toggler.collapse-icons', function () {
      var thisEl = $(this);
      var thisParent = thisEl.parents('.heading');

      if (thisParent.hasClass('open')) {
        thisParent.removeClass('open');
      } else {
        thisParent.addClass('open');
      }
    });
  }

  prestashop.on('updateProductList', function (event) {
    facetedOverride();
  });
  $(document).on('click', '.dropdown-menu.sort-order .dropdown-menu-value', function () {
    var thisClick = $(this);
    var thisParent = thisClick.parents('.dropdown-menu.sort-order');
    var dropdown = thisParent.find('.dropdown-menu--inner');

    if (thisClick.hasClass('active')) {
      thisClick.removeClass('active');
      dropdown.slideUp(300);
    } else {
      thisClick.addClass('active');
      dropdown.slideDown(300);
    }
  });
  $(document).on('click', '.dropdown-menu--listItem a', function () {
    var thisItem = $(this);
    var thisItemText = thisItem.text().trim();
    var thisItemHolder = thisItem.parents('.dropdown-menu--listItem');
    var thisMainParent = thisItem.parents('.dropdown-menu.sort-order');
    var thisDropdownClicker = thisMainParent.find('.dropdown-menu-value');
    var thisDropdownTextEl = thisMainParent.find('.dropdown-menu-valueText');
    var thisDropdownHolder = thisMainParent.find('.dropdown-menu--inner');
    console.log(thisItemText);

    if (!thisItemHolder.hasClass('active')) {
      $('.dropdown-menu--listItem').not(thisItemHolder).removeClass('active');
      $('.dropdown-menu--listItem a').not(thisItem).removeClass('current');
      thisItemHolder.addClass('active');
      setTimeout(function () {
        if ($(window).width() > 767) {
          thisDropdownTextEl.text(thisItemText);
          console.log(thisDropdownTextEl.text());
        } else {
          thisDropdownTextEl.text(thisItemText.slice(0, 15) + '...');
          console.log(thisDropdownTextEl.text());
        }
      }, 500);
      thisDropdownClicker.removeClass('active');
      thisDropdownHolder.slideUp(300);
    }
  });
  $(document).on('resize', function () {
    var thisItemText = $('.dropdown-menu--listItem a.current').text();

    if ($(window).width() > 767) {
      $('.dropdown-menu.sort-order .dropdown-menu-valueText').text(thisItemText);
    } else {
      $('.dropdown-menu.sort-order .dropdown-menu-valueText').text(thisItemText.slice(0, 15) + '...');
    }
  });
}); // The selectCategoryInner() inside prices-drop.js overrides this function

function selectCategoryInner() {
  $('.sort-by-row select').select2({
    minimumResultsForSearch: -1
  });
}

function facetedOverride() {
  var arrow = $('.facet__block .facet__header');
  arrow.on('click', function () {
    if ($(this).parents('.facet__block').hasClass('active')) {
      $(this).parents('.facet__block').removeClass('active');
      $(this).parents('.facet__block').children('.collpase--facet').slideUp();
    } else {
      $(this).parents('.facet__block').addClass('active');
      $(this).parents('.facet__block').children('.collpase--facet').slideDown();
    }
  });
}